// extracted by mini-css-extract-plugin
export default {"form":"productConfigurator_form__NpdAm"};